import { type ApolloClient } from 'apollo-client'
import { type CacheShape } from '../../../generated/graphql'
import { getCurrentAuthenticatedUser } from '@edge/spark/io-aws'
import { getCurrentUserAttributes } from '@edge/spark/io-roles'

/** @deprecated This function is no longer needed on login/logout.
 * Use `getCurrentAuthenticatedUser` to get cognito user if authenticated
 * Use `getCurrentUserAttributes` to test spark api connection
 * Not to be confused with the `updateUser` GraphQL mutation */
export const updateUser = async (client?: ApolloClient<CacheShape>): Promise<void> => {
    const user = await getCurrentAuthenticatedUser()

    if (!user) {
        throw new Error('SPARK User not found')
    }

    const userId = user.amplifyUser?.attributes?.sub // uuid

    if (!userId) {
        throw new Error('SPARK User ID not found')
    }

    const userAttributes = await getCurrentUserAttributes({ client })

    if (!userAttributes) {
        throw new Error('SPARK User data not found')
    }

    if (!userAttributes?.authenticationId) {
        throw new Error('SPARK User attributes not found')
    }
}

export default updateUser
